import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import * as React from 'react';

import { AdBannerMicrofrontendContainer } from '../AdBannerMicrofrontendContainer';
import { useSpecialProjectParameters } from './hooks/useSpecialProjectParameters';

interface IAdBannerMicrofrontendSpecialProjectContainerProps {
  manifest: IMicrofrontendManifest;
  isCommercial: boolean;
  onStub?: () => void;
  onError?: () => void;
  onClose?: () => void;
}

/**
 * Place-контейнер баннера спецпроекта над выдачей: поставляет параметры места
 * и рендерит generic-контейнер.
 */
export const AdBannerMicrofrontendSpecialProjectContainer: React.FC<
  IAdBannerMicrofrontendSpecialProjectContainerProps
> = ({ manifest, isCommercial, onStub, onError, onClose }) => {
  const parameters = useSpecialProjectParameters({ isCommercial });

  return (
    <AdBannerMicrofrontendContainer
      manifest={manifest}
      parameters={parameters}
      onStub={onStub}
      onError={onError}
      onClose={onClose}
    />
  );
};
